import { useState } from 'react';

// MUI
import { Box, Typography } from '@mui/material';

// Custom components
import CustomDashboardsList from '../../DataTables/ReportList/CustomDashboardsList';
import GridReportsList from '../../DataTables/ReportList/GridReportsList';

// Utils
import classNames from 'classnames';

// Other Libraries
import { TabsList } from './styles';

const CustomReports: React.FC<{ searchQuery?: string }> = ({
  searchQuery = '',
}) => {
  const [selectedTab, setSelectedTab] = useState('gridReports');

  return (
    <Box>
      <TabsList>
        <div
          className={classNames(
            { tab: true },
            { selectedTab: selectedTab === 'gridReports' },
          )}
          onClick={() => setSelectedTab('gridReports')}
        >
          Grid Reports
        </div>
        <div
          className={classNames(
            { tab: true },
            { selectedTab: selectedTab === 'customReports' },
          )}
          onClick={() => setSelectedTab('customReports')}
        >
          Custom Dashboards
        </div>
      </TabsList>

      {selectedTab === 'gridReports' ? (
        <GridReportsList searchQuery={searchQuery} />
      ) : (
        <CustomDashboardsList searchQuery={searchQuery} />
      )}
    </Box>
  );
};

export default CustomReports;
